/** Gift finder wizard — stored in site settings under store_copy.gift_finder */
export const GIFT_FINDER_DEFAULTS = {
  enabled: true,
  show_on_home: true,
  show_on_shop: true,
  show_in_nav: true,
  show_in_footer: true,
  nav_label: 'Gift finder',
  home_button_label: 'Find a gift',
  shop_button_label: 'Gift finder',
  eyebrow: 'Gift finder',
  title: 'Find the right piece',
  subtitle:
    "Pick from your live shop collections — we'll suggest real products from the catalog. No account needed.",
  seo_title: 'Gift finder | Saloni Designs',
  seo_description:
    'Find handcrafted pieces by collection, product type, and budget at Saloni Designs.',
  show_group_step: true,
  show_budget_step: true,
  show_recipient_step: false,
  use_admin_gift_groups: true,
  use_product_tags: true,
  auto_widen_results: true,
  gift_groups: [],
  recipients: [],
  recipient_step_title: 'Who is this gift for?',
  recipient_step_lead: 'We will suggest collections and styles that fit — you can still change answers later.',
  collection_step_title: 'Which collection?',
  collection_step_lead: 'Collections come from your catalog — rename or add categories in Admin anytime.',
  group_step_title: 'Which style or tag?',
  tag_step_lead: 'Tags are set per product in Admin — e.g. evil-eye, kids, premium.',
  budget_step_title: "What's your budget?",
  results_title: 'Picks for you',
  results_empty_message:
    'No pieces matched those filters. Try "All collections", "All types", or a wider budget.',
};
